import {CPSConstants} from "commonUtils/enumerations";

export const formValidationStyle = {
  rptValidation: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    padding: "2px 5px !important",
  },
  loginStack: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "100%",
    "& .MuiAlert-icon": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      padding: "5px 0",
    },
    "& .MuiAlert-standardError": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      alignItems: "center",
      padding: "0 10px !important",
    },
    "& .MuiAlert-standardInfo": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      alignItems: "center",
      padding: "0 10px !important",
    },
    "& .MuiAlert-standardSuccess": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      alignItems: "center",
      padding: "0 10px !important",
    },
    "& .MuiAlert-standardWarning": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      alignItems: "center",
      padding: "0 10px !important",
    },
  },
  loginalert: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontSize: CPSConstants.FONTREMTEXT,
    fontWeight: CPSConstants.FONTWEIGHT,
  },
  boxValidation: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    flexDirection: "column",
  },
};
